'use client'

import { forwardRef, useImperativeHandle, useRef, useState } from "react"
import styles from "./ua.module.scss";
import Dropdown from "@/components/dropdown/Dropdown";
import Button from "@/components/button/Button";
import Form from "@/components/form/Form";
import Field from "@/components/form/Field";
import ApiUtils from "@/utils/ApiUtils";
import Icon from "@/components/icon/Icon";
import PanelBody from "@/components/panel/PanelBody";

const LocationDropdown = forwardRef((props,ref) => {
  
  const [currZipCode, setCurrZipCode] = useState(props.site?.session?.vehicles?.location?.zip)
  const [zipCode, setZipCode] = useState(props.site?.session?.vehicles?.location?.zip)
  const dd = useRef()
  
  const toggle = () => {
    dd.current.toggle()
  }
  
  const onChange = (val) => {
    setZipCode(val)
  }
  
  const submit = (e) => {
    e.preventDefault()
    ApiUtils.getRequest("/api/location/zip-code?zip=" + zipCode)
    .then(data => {
      toggle()
      setCurrZipCode(data.location.zip)
      // router.refresh()
      window.location.reload()
    })
  }
  
  useImperativeHandle(ref, () => ({
    toggle
  }))
  
  return <Dropdown ref={dd} position={'right'} body={'padded'} offset={'12px'} title="Enter Your Location">
      <Form id="user_zip_form" theme="padded" name="User Zip" onSubmit={e => submit(e)}>
          <div className={ 'flex-row-column flex-with-gap flex-align-middle flex-nowrap'} style={{width:'360px'}}>
            <div className={'flex-col min-b-xs'}>
              Your Zip Code
            </div>
            <div className={'flex-col flex-stretch'}>
              <Field type="text" name="zip" label="Zip Code" value={zipCode} numbersOnly={true} maxLength={5} onChange={ value => onChange(value) }></Field>
            </div>
            <div className={'flex-col'}>
              <Button theme='secondary' label={'Submit'}></Button>
            </div>
          </div>
      </Form>
    </Dropdown>
  
})

LocationDropdown.displayName = "LocationDropdown"
export default LocationDropdown